/*
 *
 * ----------------------------------------------- */
jQuery(document).ready(function($){
  $('#zipcode').jpostal({
    click: '.btn-zipcode',
    postcode : [
      '#zipcode',
    ],
    address : {
      '#address-1'  : '%4',
      '#address-2'  : '%5 %6',
      '#prefecture'  : '%3',
    }
  });
});
